import React from "react";
import { css } from "@emotion/react";
import { useImageLoad } from "../../hooks/useImageLoad";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  url: string;
}

export const CardImage: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { url } = props;
  const loaded = useImageLoad(url);

  const cardImageStyles = loaded ? cardImageLoadedStyle : cardImageStyle;

  return (
    <div css={cardImageBlockStyle}>
      <img css={cardImageStyles} src={url} alt="" />
    </div>
  );
};

const cardImageBlockStyle = css`
  background-color: rgb(220, 220, 220);
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
`;
const cardImageStyle = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  flex: 1;
  transition: opacity 0.4s ease;
`;
const cardImageLoadedStyle = css`
  ${cardImageStyle};
  opacity: 1;
`;
